import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { isAxiosError } from 'axios';
import { abortController } from 'store/utils';
import { getContentManagersApi } from './api';
const initialFilters = {
    emirateIds: [],
    districtIds: [],
    companyIds: [],
    q: '',
    costLevels: undefined,
    minPrice: undefined,
    maxPrice: undefined,
    minSquare: undefined,
    maxSquare: undefined,
    pricePerAreaFrom: undefined,
    pricePerAreaTo: undefined,
    downPaymentFrom: undefined,
    downPaymentTo: undefined,
    downPaymentAmountFrom: undefined,
    downPaymentAmountTo: undefined,
    minServiceCharge: undefined,
    maxServiceCharge: undefined,
    isBuilt: undefined,
    layouts: [],
    finishingIds: [],
    featureIds: [],
    unitTypeIds: [],
    unitLevels: [],
    statuses: [],
    favorite: undefined,
    isLaunch: undefined,
};
const initialState = {
    openedFilter: undefined,
    contentManagers: [],
    filtersData: initialFilters,
};
const actions = {
    setFilters: (payload, { setState }) => {
        setState({ filtersData: { ...initialFilters, ...payload } });
    },
    changeFilters: (payload, { setState }) => {
        setState(({ filtersData }) => ({ filtersData: { ...filtersData, ...payload } }));
    },
    changeOpenedFilter: (payload, { setState }) => {
        setState({ openedFilter: payload });
    },
    clearFilters: (payload, { setState }) => {
        setState({ filtersData: initialFilters });
    },
    getContentManagers: async (payload, { setState, signal }) => {
        try {
            const { data } = await getContentManagersApi(payload?.q, signal);
            const managers = data.managers ?? [];
            setState((state) => {
                state.contentManagers = managers;
            });
            return managers;
        }
        catch (error) {
            setState((state) => {
                state.contentManagers = [];
            });
            throw isAxiosError(error) ? error.response?.data ?? error : error;
        }
    },
};
const initialStore = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(initialStore, set, get, 'Filters')), { name: 'Filters' }));
export { initialFilters, };
